import { absCmsMediaUrl } from '@/lib/cms-media';

/**
 * Maps CMS provider slugs to S3 image folder/file names when they differ.
 */
export const PROVIDER_IMAGE_SLUG_MAP: Record<string, string> = {
  'bp-games': 'bigpot-gaming',
  'champion-studio': 'champion',
  'holle-games': 'h-lle-games',
};

export function resolveProviderImageSlug(providerSlug: string): string {
  const slug = String(providerSlug ?? '').trim();
  if (!slug) return slug;
  return PROVIDER_IMAGE_SLUG_MAP[slug] ?? slug;
}

export function getProviderLogoUrl(providerSlug: string): string {
  const imageSlug = resolveProviderImageSlug(providerSlug);
  if (!imageSlug) return '';
  const base = String(process.env.NEXT_PUBLIC_STORAGE_URL ?? '').trim().replace(/\/+$/, '');
  return base ? `${base}/img/providers/${imageSlug}.webp` : `/img/providers/${imageSlug}.webp`;
}

/** Direct URL for Open Graph / Telegram (CMS logo or S3 fallback). */
export function getProviderOgImageUrl(providerSlug: string, cmsLogoUrl?: string | null): string {
  const fromCms = absCmsMediaUrl(cmsLogoUrl);
  if (fromCms) return fromCms;
  return getProviderLogoUrl(providerSlug);
}
